import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'

const getAllBikes = (): Promise<AxiosResponse> => {
  return Request.get('/bike_catalog/bikes/')
}

export default {
  getAllBikes,
}
